module.exports = __webpack_public_path__ + "img/c010_4.8b012477.jpg";